import React, { useContext } from 'react';
import { CopyContext } from '../provider/MyProvider';
import './Features.css';

export const Features = ({ navClick }) => {
  const { featureCards } = useContext(CopyContext);

  // Highlight Styling for "AGENTS" and "BRANDS"

  const yellowHighlight = {backgroundImage: "linear-gradient(to top, #E7FF52 60%, white 60%)"};
  const blueHighlight = {backgroundImage: "linear-gradient(to top, #9DE2FF 60%, white 60%)"};

  //Feature Cards Render

  const renderCards = featureCards.map((card) => {
    return (
      <div
        className="features-card"
        key={card.title}
      >
        <img
          className="features-img"
          src={card.imgUrl}
          alt={`See what TrueRep looks like for...`}
          onClick={() => navClick(card.imgUrl)}
        />
        <div className="feature-card-text">
          <h4>{card.title}</h4>
          <p className="list">{card.description}</p>
          <div>
            {card.category.map((cat) => {
                return (
                  <h4><span style={cat === "BRANDS" ? blueHighlight : yellowHighlight}>{cat}</span></h4>
                )
            })}
          </div>
        </div>
      </div>
    )
  });

  return ( 
    <section className="features">
      <div className="features-container">
        
        <h1 className="features-header">Endless Possibilities</h1>
        <h3>TrueRep has features built for <span style={yellowHighlight}>AGENTS</span> and <span style={blueHighlight}>BRANDS</span> to help them run their back offices, connect seamlessly with each other, and work smarter, not harder.</h3>
        
        <div className="features-bullets">
          {renderCards}
        </div>

      </div>
    </section>
  );
};
